<template>
  <v-container v-if="!containerInitLoading && project" fluid style="height: inherit">
    <v-row align="stretch" style="height: inherit;">
      <v-col style="max-width: 400px;">
        <EntityEditCard :title="$t('servicesystem.common_objects.commonterms.details')" :item="project"
          :saveMethod="saveChanges">
          <template v-slot:content="{ item, editMode, handleFocus }">
            <ProjectEditContent  :item="item" :editMode="editMode"
              :handleFocus="handleFocus">
            </ProjectEditContent>
          </template>
        </EntityEditCard>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import ProjectEditContent from "@/views/admin/projects/ProjectEditContent.vue";
import EntityEditCard from "@/views/layouts/EntityEditCard.vue";

export default {
  name: "ViewProjectInfo",
  props: {
    containerInitLoading: Boolean, //getting container data for the first time, show skeletonloader
    containerLoading: Boolean, //loading container data update, do so in the background with small indicator
    containerItem: Object, //container data
  },
  components: {
    EntityEditCard,
    ProjectEditContent,
  },
  mixins: [clientAPI],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
    async saveChanges(obj) {
      const dto = Object.assign({}, obj);
      await this.updateDepartment(dto)
        .then((response) => {
          this.project = response;
        })
        .catch((exception) => {
          console.error(exception);
        });
    },
  },

  computed: {
    project: {
      get() {
        return this.containerItem;
      },
      set(value) {
        this.$emit('SetContainerItem', value);
      }
    },

  },

  watch: {

  },
};
</script>


<style lang='scss'></style>